<template>
  <div class="ts-app-shell_fh">
    <div class="padd-main">
      <div class="ts-app-shell--header">
        <h5>
          <strong>My Dashboard</strong>
        </h5>
        <!-- <div class="ts-app-shell--header_actions flexed">
          <button v-if="surveyCompleted" class="ts-btn ts-btn-small" @click="vacantRoleMatches">Vacant Role Matches &nbsp;<span v-if="jobMatchesCount > 0" class="req-notif">{{jobMatchesCount}}</span></button>
          <button v-if="!surveyCompleted" class="ts-btn ts-btn-small" @click="vacantRoleMatches">Vacant Roles &nbsp;<span v-if="jobMatchesCount > 0" class="req-notif">{{jobMatchesCount}}</span></button>
        </div>         -->
      </div>

      <el-row container :gutter="24" class="bg-welcome">
        <el-col :xs="24" :md="14" :lg="14">
          <br />
          <br />
          <h5 style="padding-left: 10px">
            <strong>Welcome to</strong>
          </h5>
          <img
            src="~../../../assets/img/the-logo-welcome.png"
            style="height: 50px"
          />
          <br />
          <br />
          <p style="color: black; font-size: 18px">
            Welcome to TalentSensus! If you are looking to be matched to new
            opportunities based on your skills, wanting to identify your hidden
            talents and take control of your career. <br /><br />
            You are in the right place. We have compiled information and
            resources along with providing you a unique opportunity to change
            how people connect with job opportunities.
          </p>
        </el-col>
        <el-col :xs="24" :md="10" :lg="10" style="text-align: center">
          <img src="~../../../assets/img/welcome-welcome.svg" />
        </el-col>
      </el-row>
    </div>

    <div class="ts-app-landing-dashboard">
      <div class="padd-main">
        <el-row style="text-align: center" :gutter="10">
          <el-col style="margin-bottom: 10px" :xs="24" :md="5" :lg="5">
            <el-card shadow="hover">
              <div class="card-body" @click="goToRoleMatching">
                <h6 class="card-font">
                  View Role <br />
                  Matches
                </h6>
                <div class="dash-card">
                  <i class="fas fa-user-tie" aria-hidden="true"></i>
                </div>
                <div class="bottom clearfix">
                  <span slot="footer" class="ts-modal--footer">
                    <el-button class="ts-btn-small card-button"
                      >View
                    </el-button>
                  </span>
                </div>
              </div>
            </el-card>
          </el-col>

          <el-col style="margin-bottom: 10px" :xs="24" :md="5" :lg="5">
            <el-card shadow="hover">
              <div class="card-body" @click="updateMySGA">
                <h6 class="card-font">
                  Complete My <br />
                  Skills Profile
                </h6>
                <div class="dash-card">
                  <i class="far fa-address-card"></i>
                </div>
                <div class="bottom clearfix">
                  <span slot="footer" class="ts-modal--footer">
                    <el-button class="ts-btn-small card-button"
                      >My Task</el-button
                    >
                  </span>
                </div>
              </div>
            </el-card>
          </el-col>

          <el-col style="margin-bottom: 10px" :xs="24" :md="5" :lg="5">
            <el-card shadow="hover">
              <div class="card-body" @click="jobMatchesArchive">
                <h6 class="card-font">Job Matches<br />Archive</h6>
                <div class="dash-card">
                  <i class="fas fa-archive"></i>
                </div>
                <div class="bottom clearfix">
                  <span slot="footer" class="ts-modal--footer">
                    <el-button class="ts-btn-small card-button">View</el-button>
                  </span>
                </div>
              </div>
            </el-card>
          </el-col>

          <el-col
            style="margin-bottom: 10px"
            :xs="24"
            :md="5"
            :lg="5"
            v-if="connectionRequests.length > 0"
          >
            <el-card shadow="hover">
              <div class="card-body" @click="goToAgency">
                <h6 class="card-font">
                  Career Center <br />
                  Connections
                </h6>
                <div class="dash-card">
                  <i class="fas fa-handshake" aria-hidden="true"></i>
                </div>
                <div class="bottom clearfix">
                  <span slot="footer" class="ts-modal--footer">
                    <el-button class="ts-btn-small card-button"
                      >Manage
                    </el-button>
                  </span>
                </div>
              </div>
            </el-card>
          </el-col>

          <el-col style="margin-bottom: 10px" :xs="24" :md="5" :lg="5">
            <el-card shadow="hover">
              <div class="card-body" @click="goToUserProfileSettings">
                <h6 class="card-font">
                  Public Profile/<br />
                  Resume
                </h6>
                <div class="dash-card">
                  <i class="fas fa-user-cog"></i>
                </div>
                <div class="bottom clearfix">
                  <span slot="footer" class="ts-modal--footer">
                    <el-button class="ts-btn-small card-button">View</el-button>
                  </span>
                </div>
              </div>
            </el-card>
          </el-col>

          <el-col style="margin-bottom: 10px" :xs="24" :md="5" :lg="5">
            <el-card shadow="hover">
              <div class="card-body" @click="goToMySkillsPassport">
                <h6 class="card-font">
                  Skills<br />
                  Passport
                </h6>
                <div class="dash-card">
                  <i class="fas fa-passport"></i>
                </div>
                <div class="bottom clearfix">
                  <span slot="footer" class="ts-modal--footer">
                    <el-button class="ts-btn-small card-button"
                      >Manage</el-button
                    >
                  </span>
                </div>
              </div>
            </el-card>
          </el-col>

          <el-col style="margin-bottom: 10px" :xs="24" :md="5" :lg="5">
            <el-card shadow="hover">
              <div class="card-body" @click="goToSearchJob">
                <h6 class="card-font">
                  Search<br />
                  Job
                </h6>
                <div class="dash-card">
                  <i class="fas fa-user-md"></i>
                </div>
                <div class="bottom clearfix">
                  <span slot="footer" class="ts-modal--footer">
                    <el-button class="ts-btn-small card-button"
                      >Search</el-button
                    >
                  </span>
                </div>
              </div>
            </el-card>
          </el-col>

          <el-col style="margin-bottom: 10px" :xs="24" :md="5" :lg="5">
            <el-card shadow="hover">
              <div class="card-body" @click="goToRegistrationQuestionnaires">
                <h6 class="card-font">
                  Registration<br />
                  Questionnaires
                </h6>
                <div class="dash-card">
                  <i class="fas fa-passport"></i>
                </div>
                <div class="bottom clearfix">
                  <span slot="footer" class="ts-modal--footer">
                    <el-button class="ts-btn-small card-button"
                      >View</el-button
                    >
                  </span>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>

    <el-dialog
      id="incomplete"
      title=""
      :visible.sync="showIncompleteProfileModal"
      width="800px"
      class="ts-modal"
    >
      <button
        type="button"
        aria-label="Close"
        class="el-dialog__headerbtn"
        @click="onCloseModal(null)"
      >
        <i class="el-dialog__close el-icon el-icon-close"></i>
      </button>
      <h5>Welcome to TalentSensus!</h5>
      <br />
      <h6 style="word-break: break-word">
        To get started, you need to complete 'My Skills Profile' before you can
        apply for roles. Next, we would like you to explore the other two core
        features we offer.
      </h6>
      <br />
      <br />
      <el-row style="display: block">
        <el-col :xl="10" :lg="10" :md="10" :sm="10" :xs="24">
          <div style="margin-bottom: 10px; width: 180px; margin: auto">
            <el-tooltip class="item" effect="dark" placement="right">
              <div slot="content" style="width: 300px; word-wrap: break-word">
                {{
                  completeProfileCriteria.sgaCompleted == true
                    ? "You have completed your skills profile"
                    : "You have not completed your skills profile yet!"
                }}
              </div>
              <el-card
                shadow="hover"
                v-bind:style="
                  completeProfileCriteria.sgaCompleted == true
                    ? 'box-shadow: rgb(0 140 17 / 89%) 0px 3px 10px'
                    : 'box-shadow: 0 3px 10px rgb(255 4 4 / 89%)'
                "
                style="text-align: center !important; margin: auto"
              >
                <div class="card-body" @click="updateMySGA">
                  <h6 class="card-font">
                    Complete My <br />
                    Skills Profile
                  </h6>
                  <div class="dash-card">
                    <i
                      class="far fa-address-card"
                      aria-hidden="true"
                      style="font-size: 50px; padding: 10px"
                    ></i>
                  </div>
                  <div class="bottom clearfix">
                    <span slot="footer" class="ts-modal--footer">
                      <el-button
                        class="ts-btn-small card-button"
                        style="
                          width: 100%;
                          background-color: #00c8dc;
                          color: white;
                          pointer-events: none;
                        "
                        >My Task
                      </el-button>
                    </span>
                  </div>
                </div>
              </el-card>
            </el-tooltip>
            <v-icon
              style="width: 12; height: 12"
              class="check_indicator"
              v-if="completeProfileCriteria.sgaCompleted == true"
              name="check-circle"
            />
          </div>
        </el-col>
        <el-col :xl="14" :lg="14" :md="14" :sm="14" :xs="24">
          <br />
          <h6 class="card-font">Complete your details</h6>
          <p>
            Here you will be able to enter your personal details from education, 
            work history, certifications, and the company culture you desire to 
            work with. 
          </p>
        </el-col> </el-row
      ><br />
      <el-row style="display: block">
        <el-col :xl="10" :lg="10" :md="10" :sm="10" :xs="24">
          <div style="margin-bottom: 10px; width: 180px; margin: auto">
            <el-tooltip class="item" effect="dark" placement="right">
              <div slot="content" style="width: 300px; word-wrap: break-word">
                {{
                  completeProfileCriteria.numberOfVacantMatchDone >=
                  doneCriteria
                    ? "You have reached role matching criteria"
                    : "You have " +
                      completeProfileCriteria.numberOfVacantMatchDone +
                      "/" +
                      doneCriteria +
                      " role matching done."
                }}
              </div>
              <el-card
                shadow="hover"
                v-bind:style="
                  completeProfileCriteria.numberOfVacantMatchDone >=
                  doneCriteria
                    ? 'box-shadow: rgb(0 140 17 / 89%) 0px 3px 10px'
                    : 'box-shadow: 0 3px 10px rgb(255 4 4 / 89%)'
                "
                style="text-align: center !important; margin: auto"
              >
                <div class="card-body" @click="goToRoleMatching">
                  <h6 class="card-font">
                    Vacant Role <br />
                    Matches
                  </h6>
                  <div class="dash-card">
                    <i
                      class="fas fa-user-tie"
                      aria-hidden="true"
                      style="font-size: 50px; padding: 10px"
                    ></i>
                  </div>
                  <div class="bottom clearfix">
                    <span slot="footer" class="ts-modal--footer">
                      <el-button
                        class="ts-btn-small card-button"
                        style="
                          width: 100%;
                          background-color: #00c8dc;
                          color: white;
                          pointer-events: none;
                        "
                        >View
                      </el-button>
                    </span>
                  </div>
                </div>
              </el-card>
            </el-tooltip>
            <v-icon
              style="width: 12; height: 12"
              class="check_indicator"
              v-if="
                completeProfileCriteria.numberOfVacantMatchDone >= doneCriteria
              "
              name="check-circle"
            />
          </div>
        </el-col>
        <el-col :xl="14" :lg="14" :md="14" :sm="14" :xs="24">
          <br />
          <h6 class="card-font">Check your role matching</h6>
          <p>
            Here you can see jobs that talentsensus have matched to your
            profile. Visit this page to find out how to apply
          </p>
        </el-col> </el-row
      ><br />
      <el-row style="display: block">
        <el-col :xl="10" :lg="10" :md="10" :sm="10" :xs="24">
          <div style="margin-bottom: 10px; width: 180px; margin: auto">
            <el-tooltip class="item" effect="dark" placement="right">
              <div slot="content" style="width: 300px; word-wrap: break-word">
                {{
                  completeProfileCriteria.numberOfSearchJobDone >= doneCriteria
                    ? "You have reached job searching criteria"
                    : "You have " +
                      completeProfileCriteria.numberOfSearchJobDone +
                      "/" +
                      doneCriteria +
                      " job search done."
                }}
              </div>
              <el-card
                shadow="hover"
                v-bind:style="
                  completeProfileCriteria.numberOfSearchJobDone >= doneCriteria
                    ? 'box-shadow: rgb(0 140 17 / 89%) 0px 3px 10px'
                    : 'box-shadow: 0 3px 10px rgb(255 4 4 / 89%)'
                "
                style="text-align: center !important; margin: auto"
              >
                <div class="card-body" @click="goToSearchJob">
                  <h6 class="card-font">
                    Search <br />
                    Job
                  </h6>
                  <div class="dash-card">
                    <i
                      class="fas fa-user-md"
                      aria-hidden="true"
                      style="font-size: 50px; padding: 10px"
                    ></i>
                  </div>
                  <div class="bottom clearfix">
                    <span slot="footer" class="ts-modal--footer">
                      <el-button
                        class="ts-btn-small card-button"
                        style="
                          width: 100%;
                          background-color: #00c8dc;
                          color: white;
                          pointer-events: none;
                        "
                        >Search
                      </el-button>
                    </span>
                  </div>
                </div>
              </el-card>
            </el-tooltip>
            <v-icon
              style="width: 12; height: 12"
              class="check_indicator"
              v-if="
                completeProfileCriteria.numberOfSearchJobDone >= doneCriteria
              "
              name="check-circle"
            />
          </div>
        </el-col>
        <el-col :xl="14" :lg="14" :md="14" :sm="14" :xs="24">
          <br />
          <h6 class="card-font">Know the job you are looking for?</h6>
          <p>
            Here is where you can identify a specific job you want or search for
            a target company's job vacancies and apply.
          </p>
        </el-col>
      </el-row>
      <div class="el-dialog__footer" style="padding: 50px">
        <button
          class="ts-btn ts-btn-rounded ts-btn-secondary"
          style="margin: auto; width: 300px"
          @click="onCloseModal(null)"
        >
          Continue
        </button>
      </div>
    </el-dialog>
    <el-dialog
      id="completed"
      title=""
      :visible.sync="showCompleteProfileModal"
      width="800px"
      class="ts-modal"
    >
      <button
        type="button"
        aria-label="Close"
        class="el-dialog__headerbtn"
        @click="onCloseCompleteProfileModal(null)"
      >
        <i class="el-dialog__close el-icon el-icon-close"></i>
      </button>
      <h5>Congratulations!</h5>
      <br />
      <h5>
        You have successfully managed and explored core features of
        talentsensus.
      </h5>
      <br />
      <div class="content-completed">
        <br />
        <el-row style="display: block">
          <el-col :xl="10" :lg="10" :md="10" :sm="10" :xs="24">
            <div style="margin-bottom: 10px; width: 180px; margin: auto">
              <el-tooltip class="item" effect="dark" placement="right">
                <div slot="content" style="width: 300px; word-wrap: break-word">
                  {{
                    completeProfileCriteria.sgaCompleted == true
                      ? "You have completed your skills profile"
                      : "You have not completed your skills profile yet!"
                  }}
                </div>
                <el-card
                  shadow="hover"
                  v-bind:style="
                    completeProfileCriteria.sgaCompleted == true
                      ? 'box-shadow: rgb(0 140 17 / 89%) 0px 3px 10px'
                      : 'box-shadow: 0 3px 10px rgb(255 4 4 / 89%)'
                  "
                  style="text-align: center !important; margin: auto"
                >
                  <div class="card-body" @click="updateMySGA">
                    <h6 class="card-font">
                      Complete My <br />
                      Skills Profile
                    </h6>
                    <div class="dash-card">
                      <i
                        class="far fa-address-card"
                        aria-hidden="true"
                        style="font-size: 50px; padding: 10px"
                      ></i>
                    </div>
                    <div class="bottom clearfix">
                      <span slot="footer" class="ts-modal--footer">
                        <el-button
                          class="ts-btn-small card-button"
                          style="
                            width: 100%;
                            background-color: #00c8dc;
                            color: white;
                            pointer-events: none;
                          "
                          >My Task
                        </el-button>
                      </span>
                    </div>
                  </div>
                </el-card>
              </el-tooltip>
              <v-icon
                style="width: 12; height: 12"
                class="check_indicator"
                v-if="completeProfileCriteria.sgaCompleted == true"
                name="check-circle"
              />
            </div>
          </el-col>
          <el-col :xl="14" :lg="14" :md="14" :sm="14" :xs="24">
            <!-- <br/>
            <h6 class="card-font">Complete your details </h6>
            <p>
              Here you were able to enter your personal details from education, work history, certifications, up to company culture you desired to work with.
            </p> -->
          </el-col> </el-row
        ><br />
        <el-row style="display: block">
          <el-col :xl="10" :lg="10" :md="10" :sm="10" :xs="24">
            <div style="margin-bottom: 10px; width: 180px; margin: auto">
              <el-tooltip class="item" effect="dark" placement="right">
                <div slot="content" style="width: 300px; word-wrap: break-word">
                  {{
                    completeProfileCriteria.numberOfVacantMatchDone >=
                    doneCriteria
                      ? "You have reached role matching criteria"
                      : "You have " +
                        completeProfileCriteria.numberOfVacantMatchDone +
                        "/" +
                        doneCriteria +
                        " role matching done."
                  }}
                </div>
                <el-card
                  shadow="hover"
                  v-bind:style="
                    completeProfileCriteria.numberOfVacantMatchDone >=
                    doneCriteria
                      ? 'box-shadow: rgb(0 140 17 / 89%) 0px 3px 10px'
                      : 'box-shadow: 0 3px 10px rgb(255 4 4 / 89%)'
                  "
                  style="text-align: center !important; margin: auto"
                >
                  <div class="card-body" @click="goToRoleMatching">
                    <h6 class="card-font">
                      Vacant Role <br />
                      Matches
                    </h6>
                    <div class="dash-card">
                      <i
                        class="fas fa-user-tie"
                        aria-hidden="true"
                        style="font-size: 50px; padding: 10px"
                      ></i>
                    </div>
                    <div class="bottom clearfix">
                      <span slot="footer" class="ts-modal--footer">
                        <el-button
                          class="ts-btn-small card-button"
                          style="
                            width: 100%;
                            background-color: #00c8dc;
                            color: white;
                            pointer-events: none;
                          "
                          >View
                        </el-button>
                      </span>
                    </div>
                  </div>
                </el-card>
              </el-tooltip>
              <v-icon
                style="width: 12; height: 12"
                class="check_indicator"
                v-if="
                  completeProfileCriteria.numberOfVacantMatchDone >=
                    doneCriteria
                "
                name="check-circle"
              />
            </div>
          </el-col>
          <el-col :xl="14" :lg="14" :md="14" :sm="14" :xs="24">
            <!-- <br/>
            <h6 class="card-font">Check your role matching</h6>
            <p>
              Here you can see jobs where talentsensus have matched to your profile. Make sure to always visit this page and be ready to apply.
            </p> -->
          </el-col> </el-row
        ><br />
        <el-row style="display: block">
          <el-col :xl="10" :lg="10" :md="10" :sm="10" :xs="24">
            <div style="margin-bottom: 10px; width: 180px; margin: auto">
              <el-tooltip class="item" effect="dark" placement="right">
                <div slot="content" style="width: 300px; word-wrap: break-word">
                  {{
                    completeProfileCriteria.NumberOfSearchJobDone >=
                    doneCriteria
                      ? "You have reached job searching criteria"
                      : "You have " +
                        completeProfileCriteria.numberOfSearchJobDone +
                        "/" +
                        doneCriteria +
                        " job search done."
                  }}
                </div>
                <el-card
                  shadow="hover"
                  v-bind:style="
                    completeProfileCriteria.numberOfSearchJobDone >=
                    doneCriteria
                      ? 'box-shadow: rgb(0 140 17 / 89%) 0px 3px 10px'
                      : 'box-shadow: 0 3px 10px rgb(255 4 4 / 89%)'
                  "
                  style="text-align: center !important; margin: auto"
                >
                  <div class="card-body" @click="goToSearchJob">
                    <h6 class="card-font">
                      Search <br />
                      Job
                    </h6>
                    <div class="dash-card">
                      <i
                        class="fas fa-user-md"
                        aria-hidden="true"
                        style="font-size: 50px; padding: 10px"
                      ></i>
                    </div>
                    <div class="bottom clearfix">
                      <span slot="footer" class="ts-modal--footer">
                        <el-button
                          class="ts-btn-small card-button"
                          style="
                            width: 100%;
                            background-color: #00c8dc;
                            color: white;
                            pointer-events: none;
                          "
                          >Search
                        </el-button>
                      </span>
                    </div>
                  </div>
                </el-card>
              </el-tooltip>
              <v-icon
                style="width: 12; height: 12"
                class="check_indicator"
                v-if="
                  completeProfileCriteria.numberOfSearchJobDone >= doneCriteria
                "
                name="check-circle"
              />
            </div>
          </el-col>
          <el-col :xl="14" :lg="14" :md="14" :sm="14" :xs="24"> </el-col>
        </el-row>
      </div>
      <div class="el-dialog__footer" style="padding: 50px; text-align: center">
        <button
          class="ts-btn ts-btn-rounded ts-btn-secondary"
          style="margin: auto; width: 300px"
          @click="ConfirmCompleteProfile(null)"
        >
          Thanks! don't show this anymore
        </button>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="showEducationModal"
      :close-on-click-modal="false"
      :show-close="false"
      width="420px"
      class="ts-modal"
    >
      <button
        type="button"
        aria-label="Close"
        class="el-dialog__headerbtn"
        @click="closeEducationModal(null)"
      >
        <i class="el-dialog__close el-icon el-icon-close"></i>
      </button>

      <h6 style="word-break: normal">
        Your education details need some attention!
      </h6>
      <br />
      <span style="font-size: 14px; word-break: normal"
        >Please update your education listed below as their graduation dates
        have passed. Move the graduation date to a later date, remove the
        education, or make the education completed by removing the graduation
        date.</span
      ><br />
      <div class="education-details">
        <el-table
          :data="educationDetails.courseDetails"
          stripe
          style="width: 100%"
          height="400"
        >
          <el-table-column label="Title" width="180">
            <template slot-scope="scope">
              <span style="word-break: normal">{{
                scope.row.courseTitle | moment("MMMM DD, YYYY")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Graduation Date" width="160">
            <template slot-scope="scope">
              <span>{{
                scope.row.graduationDate | moment("MMMM DD, YYYY")
              }}</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- <div v-for="(detail, index) in educationDetails.CourseDetails" :key="index">
          <span> {{ detail.CourseTitle }} - {{ detail.GraduationDate | moment("MMMM DD, YYYY") }}</span> <br/>
        </div> -->
      </div>

      <div
        class="el-dialog__footer"
        style="padding-left: 80px; padding-top: 30px; text-align: center"
      >
        <el-button
          @click="updateEducationDetail"
          style="width: 180px"
          class="ts-btn ts-btn-small ts-btn-secondary"
          >Update Education Details</el-button
        >
      </div>
    </el-dialog>
    <TSLoading :active="isLoading" :defaultMessage="'Please wait...'" :altMessage="'Please hold on for a moment while we process the data...'"/>
    <LoginModal :showLoginModal="showLoginModal" @showLoadingFromModal="showLoadingFromModal" @hideLoadingFromModal="hideLoadingFromModal"/>
  </div>
</template>

<script>
import TSLoading from '../../../components/TSLoading.vue';
import LoginModal from '../components/LoginModal.vue';

export default {
  components: {
    TSLoading,
    LoginModal
  },
  created() {
    this.isLoading = true;
    this.$store.dispatch("jobseeker/getRegistrationAnswerByJobSeekerId", this.$store.state.account.applicant_user_info.jobSeekerId)
      .then((res) => {
        this.isLoading = false;

        if(res.isCompleted) {
          this.loadData();
        } else {
          this.goToRegistrationQuestionnaires();
        }
      })
      .catch((res) => { 
        this.goToRegistrationQuestionnaires();       
      });
        
  },
  computed: {
    currentUser() {
      return this.$store.state.account.current_user;
    },
    doneCriteria() {
      return parseInt(process.env.VUE_APP_PROCESS_DONE_BASELINE);
    }
  },
  data() {
    return {
      sgaEmployeeInfo: {},
      jobMatchesCount: 0,
      surveyCompleted: false,
      connectionRequests: [],
      showIncompleteProfileModal: false,
      showCompleteProfileModal: false,
      completeProfileCriteria: {},
      educationDetails: {},
      showEducationModal: false,
      isLoading: false,
      showLoginModal: false,
    };
  },
  methods: {
    loadData() {
      if (sessionStorage.getItem("fromSuperAdmin") != null) {
        this.$store.dispatch("account/restore").then(() => {});
      }

      if(localStorage.getItem("remote-checkin") != 'true')
          this.showLoginModal = true;
      else
        this.showLoginModal = false;

      this.surveyCompleted = this.$store.state.account.current_user.skillProfileCompleted;

      this.$store.dispatch("jobseeker/getagencyconnectionrequests").then(res => {
        this.connectionRequests = res;
      });
      
      this.$store.dispatch("account/getuserfamiliarity").then(res => {
        const process_baseline = process.env.VUE_APP_PROCESS_DONE_BASELINE;
        this.completeProfileCriteria = res;
        if (
          res.sgaCompleted == true &&
          res.numberOfVacantMatchDone >= parseInt(process_baseline) &&
          res.numberOfSearchJobDone >= parseInt(process_baseline) &&
          res.confirmed == false
        ) {
          this.showCompleteProfileModal = true;
          this.showIncompleteProfileModal = false;
        } else if (res.confirmed == false) {
          this.showCompleteProfileModal = false;
          this.showIncompleteProfileModal = true;
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
    },
    showLoadingFromModal() {
      this.isLoading = true;
    },
    hideLoadingFromModal() {
      this.isLoading = false;
      this.showLoginModal = false;
    },
    onCloseModal() {
      this.showIncompleteProfileModal = false;
    },
    onCloseCompleteProfileModal() {
      this.showCompleteProfileModal = false;
    },
    ConfirmCompleteProfile() {
      this.$store.dispatch("account/confirmcompleteprofile").then(res => {
        this.onCloseCompleteProfileModal();
      });
    },
    updateMySGA() {
      this.$router.push({ name: "sgaIntro" });
    },
    completeSurvey() {
      var x = (window.location.href =
        window.location.origin + "/jobseeker/anonymous-survey");
    },
    vacantRoleMatches() {
      this.$router.push({ name: "VacantRoleMatches" });
    },
    covid19dashboard() {
      this.$router.push({ name: "Covid19Dashboard" });
    },
    jobMatchesArchive() {
      this.$router.push({ name: "JobMatchesArchive" });
    },
    goToAgency() {
      this.$router.push({ name: "agency-dashboard" });
    },
    goToRoleMatching() {
      if (this.completeProfileCriteria.sgaCompleted != true) {
        this.$confirm(
          `You must complete your Skills Profile first!`,
          "Warning",
          {
            confirmButtonText: "OK",
            showCancelButton: false,
            type: "warning",
            dangerouslyUseHTMLString: true,
            center: true
          }
        ).then(() => {});
      } else this.$router.push({ name: "role-matching" });
    },
    goToUserProfileSettings() {
      if (this.completeProfileCriteria.sgaCompleted != true) {
        this.$confirm(
          `You must complete your Skills Profile first!`,
          "Warning",
          {
            confirmButtonText: "OK",
            showCancelButton: false,
            type: "warning",
            dangerouslyUseHTMLString: true,
            center: true
          }
        ).then(() => {});
      } else this.$router.push({ name: "JobSeekerProfilePageSetting" });
    },
    goToMySkillsPassport() {
      this.$router.push({ name: "JobSeekerSkillsPassport" });
    },
    goToSearchJob() {
      this.$router.push({ name: "search-jobs" });
    },
    closeEducationModal() {
      this.showEducationModal = false;
    },
    updateEducationDetail() {
      this.$router.push({ name: "sgaEducation" });
    },
    goToRegistrationQuestionnaires() {
      this.$router.push({ name: "RegistrationQuestionnaireOne" });
    },
  }
};
</script>
<style lang="scss">
@import "../../../assets/scss/project/dashboard.scss";

.req-notif {
  color: white;
  border: 1px solid #d30606;
  background-color: #d30606;
  border-radius: 10px;
  width: 30px;
}

.el-card.virus .card-body.virus:hover div {
  color: red !important;
}

.bg-welcome {
  background-image: url(~../../../assets/img/div-bg-welcome.png);
  background-repeat: no-repeat;
  height: auto;
}
// .center {
//   display: block;
//   margin-left: auto;
//   margin-right: auto;
//   width: 50%;
// }

#completed .el-dialog__body {
  background-image: url("~../../../assets/img/Congratulations.gif");
  background-size: contain;
  padding: 30px 20px 30px 20px;
  position: unset;
  border: none;
  background-repeat: no-repeat;
}

// .el-dialog__body{
// padding: 0px 20px 0px 20px !important;
// }
.check_indicator {
  color: #31a537;
  width: 50px !important;
  height: 50px !important;
  float: right;
  margin-top: -40px;
  margin-right: -30px;
}
</style>
